export class UpiCodeResponse {

    merchantTnxId: string;
    qrString: string;
}
